import { login, loginByPhone, logout, getInfo, refreshToken } from '@/api/login'
import { getToken, setToken, setExpiresIn, removeToken, setCurrentUser, removeCurrentUser } from '@/utils/auth'
import { Message } from 'element-ui'
import Cookies from 'js-cookie';

const user = {
  state: {
    token: getToken(),
    id: '',
    name: '',
    avatar: '',
    roles: [],
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const loginNo = userInfo.loginNo.trim()
      const password = userInfo.password
      const vcode = userInfo.vcode
      const vcodeId = userInfo.vcodeId
      const usertype = userInfo.usertype
      return new Promise((resolve, reject) => {
        login(loginNo, password, vcode, vcodeId, usertype).then(res => {
          if (res.code == 200) {
            let data = res.data
            Cookies.set('SXZW_TOKEN', data.sxzw_token)
            setToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            setExpiresIn(data.expires_in)
            commit('SET_EXPIRES_IN', data.expires_in)
            let currentUser = res.data.user_info; //个人信息
            setCurrentUser(currentUser);
            resolve()
          } else {
            Message({ message: res.msg, type: 'error' })
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 手机号登录
    LoginByPhone({ commit }, userInfo) {
      const { userType, username, smscode } = userInfo
      return new Promise((resolve, reject) => {
        loginByPhone(userType, username, smscode).then(res => {
          if (res.code == 200) {
            let data = res.data
            Cookies.set('SXZW_TOKEN', data.sxzw_token)
            setToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            setExpiresIn(data.expires_in)
            commit('SET_EXPIRES_IN', data.expires_in)
            let currentUser = res.data.user_info; //个人信息
            setCurrentUser(currentUser);
            resolve()
          } else {
            Message({ message: res.msg, type: 'error' })
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          const avatar = (user.avatar == "" || user.avatar == null) ? '' : user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_ID', user.userId)
          commit('SET_NAME', user.userName)
          commit('SET_AVATAR', avatar)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          removeCurrentUser()
          this.isLogin = false
          this.userInfo = null
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
